(() => {
  if (window.fabricMouseHoopFittingReady) return;
  window.fabricMouseHoopFittingReady = true;
  const variantId = '57061805326710';
  const selector = 'select[data-fm-hoop-fitting]';
  document.addEventListener('change', (event) => {
    if (!event.target.matches(selector)) return;
    document.querySelectorAll(selector).forEach((select) => { select.value = event.target.value; });
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const variant = form.querySelector('[name="id"]');
    if (!variant || variant.value !== variantId) return;
    const select = form.querySelector(selector);
    if (!select) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/products/5in1-magnetic-hoops-for-brother-pr-vr');
      return;
    }
    if (!select.value) {
      event.preventDefault();
      event.stopImmediatePropagation();
      select.reportValidity();
      select.focus();
    }
  }, true);
})();